import { ActionRequest, CommandRequest, SendTransactionResponse } from '@stellab/cs-schemas';
import axios, { AxiosRequestConfig } from 'axios';

import config from '@/config';
import { devLog, replaceJsonBuffers } from '@utils/helpers';

export const getAxios = (options: AxiosRequestConfig = {}) => {
  return axios.create({
    headers: {
      'X-API-Key': config.apiKey,
    },
    ...options,
  });
};

export const handleLoadingProgress = (
  e: ProgressEvent,
  setLoadingProgress: (value: React.SetStateAction<number>) => void,
) => {
  const progress = (e.loaded / e.total) * 100;
  devLog(`Loaded: ${e.loaded}, Total: ${e.total}, Progress: ${progress}`);
  setLoadingProgress(Math.round(progress));
};

export const postCommand = async (data: CommandRequest): Promise<SendTransactionResponse> => {
  devLog(`Posting command request: ${data.command}`);
  const url = `${config.backend}/blockchain/command`;
  return getAxios()
    .post(url, data)
    .then(res => res.data);
};

export const postAction = async <T>(data: ActionRequest) => {
  devLog(`Posting action request: ${data.action}`);

  const url = `${config.backend}/blockchain/action`;

  return getAxios()
    .post<T>(url, data)
    .then(res => replaceJsonBuffers(res.data)); // The replaceJsonBuffers helper is required to convert JSON buffers to regular buffers
};
